import { objectOf, maybe } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiAgentIdLogsDetailResult = objectOf({
  result: objectOf({
    invocation_id: string,
    start_time: number,
    duration: number,
    is_error: boolean,
    prompt: string,
    response_message: string,
    system_instructions: maybe(string),
  }),
});
